export class Email2 {
    
    public name:string;
    public email:string;
    public subject:string;
    public message:string;
    public date:string;

    constructor(name:string,email:string,subject:string,message:string,date:string){
        
        this.name=name;
        this.email=email;
        this.subject=subject;
        this.message=message;
        this.date=date;
    }
}


// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/models/email2.model.ts